import React, { useEffect } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import place1 from '../assets/place1.png';
import place2 from '../assets/place2.png';
import place3 from '../assets/place3.png';
import place4 from '../assets/place4.png';
import place5 from '../assets/place5.png';
import place6 from '../assets/place6.png';

const LocationScroller = () => {
  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
  }, []);

  const destinations = [
    { img: place1, title: "Guna Cave" },
    { img: place2, title: "Pillar Rocks" },
    { img: place3, title: "Bear Shola Falls" },
    { img: place4, title: "Kodai Lake" },
    { img: place5, title: "Berijam Lake" },
    { img: place6, title: "Coakers Walk" },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="text-center my-5">
      <h2 className="fw-bold mb-4">Explore destinations around Elkar’s</h2>
      <div className="container-fluid px-4">
        <Slider {...settings}>
          {destinations.map((item, i) => (
            <div key={i} className="px-3">
              <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                <img src={item.img} alt={item.title} className="card-img-top" />
              </div>
              <h5 className="fw-bold mt-3">{item.title}</h5>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default LocationScroller;
